import { useQuery } from '@tanstack/react-query'
import { LinkLikeButton } from 'components/core/button'
import { requestQuery } from 'lib/api/fetch-api'
import { useState } from 'react'
import BillingPaymentsModal from './billing-payments-modal'

export default function BillingPaymentMethods() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { data } = useQuery({
    queryKey: ['payment-methods'],
    queryFn: requestQuery({ endpoint: 'getPaymentMethods' }),
    retry: 3,
  })

  const paymentMethod = data?.length ? data[0] : null

  return (
    <div className="tw-w-full tw-rounded-lg tw-bg-white tw-p-4 tw-shadow-md">
      <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">
        <strong>Payment Method</strong>
        <LinkLikeButton color="primary" onClick={() => setIsModalOpen(true)} className="tw-font-normal">
          Update payment method
        </LinkLikeButton>
      </div>
      {paymentMethod && (
        <>
          <div className="tw-py-2">
            <div className="tw-flex tw-items-center tw-justify-between">
              <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2">
                <div className="tw-flex tw-items-center tw-gap-2">
                  <h4 className="tw-m-0 tw-p-0 tw-text-base tw-font-semibold">
                    {paymentMethod.object === 'card' ? paymentMethod.brand : paymentMethod.bankName}
                  </h4>
                  {paymentMethod.object === 'card' ? (
                    <div>•••• •••• •••• {paymentMethod.last4}</div>
                  ) : (
                    <div>•••••••••••• {paymentMethod.last4}</div>
                  )}
                </div>
                <h4 className="tw-m-0 tw-p-0 tw-text-base tw-font-normal">
                  {paymentMethod.object === 'card' ? 'Credit Card' : 'ACH'}
                </h4>
              </div>
            </div>
          </div>
          <BillingPaymentsModal open={isModalOpen} setOpen={setIsModalOpen} currentPaymentMethod={paymentMethod} />
        </>
      )}
    </div>
  )
}
